import { TLogItem } from "domain/webhook/types"
import { formatDateWithYear } from "domain/core/utils"
import { replaceName } from "domain/webhook/utils"

export const mapHeadersToArray = (data) => {
  return Object.keys(data).reduce((acc, key) => {
    acc.push({
      id: `${key}-${data[key]}`,
      name: key,
      value: data[key],
    })

    return acc
  }, [])
}

export const dataToRow = (data) => ({
  id: data.id,
  name: data.name,
  url: data.url,
  apiVersion: data.apiVersion,
  isActive: data.isActive,
  events: data.events,
  secretKey: data.secretKey,
  headers: data.headers ? mapHeadersToArray(data.headers) : [],
})

export const dataToListRow = (data) => ({
  id: data.webhookEventId,
  webhookId: data.webhookSettingsId,
  name: replaceName(data.eventName),
  status: data.status,
  date: data.createdAt,
})

export const mapHeadersArrayToObject = (arr): { [key: string]: string } => {
  const result = arr.reduce((acc, item) => {
    if (item.name && item.value) {
      acc[item.name] = item.value
    }

    return acc
  }, {})

  return result
}

export const mapToReqModel = (data) => ({
  name: data.name,
  url: data.url,
  apiVersion: data.apiVersion,
  isActive: data.isActive,
  events: data.events,
  headers: !data.headers.length ? {} : mapHeadersArrayToObject(data.headers),
})

export const mapLogsData = (list: TLogItem[]) => {
  const groups = []
  const groupCounts = []
  const data = []

  list.forEach((item) => {
    const date = formatDateWithYear(item.createdAt)

    const isInGroups = groups.find((item) => item === date)
    if (!isInGroups) {
      groups.push(date)
      groupCounts.push(1)
    } else groupCounts[groupCounts.length - 1] += 1

    data.push({
      id: item.logId,
      ...item,
    })
  })

  return {
    data,
    groupCounts,
    groups,
  }
}
